module.exports = "#ifdef USE_TEMPLATE_AO\nuniform float wallX0;\nuniform float wallX1;\n#endif\n";